import FetchMeta from "../../../../utilities/data/model/FetchMeta";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { View } from "react-native-ui-lib";
import { compose } from "recompose";
import { withDatabase } from "@nozbe/watermelondb/DatabaseProvider";
import { Database } from "@nozbe/watermelondb";
import { Text } from "@towersystems/roam-common-native";

const getObserables = ({
  fetchMeta,
  database,
}: {
  fetchMeta: FetchMeta;
  database: Database;
}) => ({
  fetchMeta: fetchMeta.observe(),
  count: database.get(fetchMeta.id).query().observeCount(),
});

interface ObservedSummaryCountProps
  extends ExtractedObservables<ReturnType<typeof getObserables>> {}

const ObservedSummaryCountRenderer = ({ count }: ObservedSummaryCountProps) => {
  return (
    <View>
      <Text style={{ opacity: 0.5 }}>{`${count} items`}</Text>
    </View>
  );
};

export const ObservedSummaryCount = compose(
  withDatabase,
  withObservables(["fetchMeta"], getObserables)
  // @ts-ignore
)(ObservedSummaryCountRenderer);
